import { GridColDef } from '@mui/x-data-grid';

import { TrackingAction } from 'openapi';

import { COLUMNS_DEFAULT_OPTIONS } from 'utils/constants/constants';
import { TRACKING_ACTIONS_TRANSLATION_KEYS } from 'utils/constants/documentsSummary';
import { TranslateFunction } from 'utils/interfaces/Translations';

import { formatMoneyWithCurrency } from './moneyHelper';

const getTimePeriodData = (
  rowValues: any[],
  period: string,
  showValue: boolean,
  currency: string
) => {
  if (!rowValues || !Array.isArray(rowValues)) return '';
  const found = rowValues.find((item: any) => item.timePeriod === period);
  if (!found) {
    return '';
  }
  if (!found.count) {
    return '-';
  }
  return showValue
    ? formatMoneyWithCurrency(found.value, currency)
    : (found.count ?? '');
};

export const getDocumentInfoColumns = (
  translate: TranslateFunction,
  showValues: boolean,
  currency: string
): GridColDef[] => {
  const columns: GridColDef[] = [
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: 'action',
      headerName: '',
      align: 'left',
      headerAlign: 'left',
      sortable: false,
      flex: 0.5,
      cellClassName: 'boldCell',
      valueGetter: (value: any, row: any) => {
        return translate(
          TRACKING_ACTIONS_TRANSLATION_KEYS[row.action as TrackingAction]
        );
      }
    },
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: 'twentyFourHours',
      headerName: translate('labels.twentyFourHours'),
      align: 'left',
      headerAlign: 'left',
      sortable: false,
      flex: 0.5,
      valueGetter: (value: any, row: any) => {
        return getTimePeriodData(
          row.values,
          'TWENTY_FOUR_HOURS',
          showValues,
          currency
        );
      }
    },
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: 'sevenDays',
      headerName: translate('labels.sevenDays'),
      align: 'left',
      headerAlign: 'left',
      flex: 0.5,
      sortable: false,
      valueGetter: (value: any, row: any) => {
        return getTimePeriodData(
          row.values,
          'SEVEN_DAYS',
          showValues,
          currency
        );
      }
    },
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: 'fourteenDays',
      headerName: translate('labels.fourteenDays'),
      align: 'left',
      headerAlign: 'left',
      flex: 0.5,
      sortable: false,
      valueGetter: (value: any, row: any) => {
        return getTimePeriodData(
          row.values,
          'FOURTEEN_DAYS',
          showValues,
          currency
        );
      }
    },
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: 'twentyEightDays',
      headerName: translate('labels.twentyEightDays'),
      align: 'left',
      headerAlign: 'left',
      flex: 0.5,
      sortable: false,
      valueGetter: (_value: any, row: any) => {
        return getTimePeriodData(
          row.values,
          'TWENTY_EIGHT_DAYS',
          showValues,
          currency
        );
      }
    }
  ];

  return columns;
};
